import { Button, ButtonProps, SxProps, Theme } from "@mui/material";
import { lighten } from "@mui/material/styles";
import { ReactNode } from "react";
import { ButtonsColorType, ButtonsType } from "../../types/enums";
import { buttonColorMapper } from "../../types/genereal";

type Props = ButtonProps & {
  children: ReactNode;
  buttonType?: ButtonsType;
  fullWidth?: boolean;
  buttonColor?: ButtonsColorType;
  height?: string;
  sx?: SxProps<Theme>;
};

export const ReuseButton = ({
  children,
  fullWidth = false,
  buttonColor = ButtonsColorType.blue,
  buttonType = ButtonsType.outlined,
  height = "36px",
  sx,
  ...props
}: Props) => {
  const { textColor, borderColor, customGradientColor } =
    buttonColorMapper[buttonColor];

  const backgroundStyle = props.disabled
    ? "#EEEEEE"
    : customGradientColor
      ? `linear-gradient(to right, ${customGradientColor}, ${borderColor})`
      : borderColor;

  const isText = buttonType === ButtonsType.text;
  const isContained = buttonType === ButtonsType.contained;
  const isOutlined = buttonType === ButtonsType.outlined;

  const border =
    isText || isContained || props.disabled
      ? isOutlined
        ? `1px solid "#EEEEEE"`
        : "none"
      : `1px solid ${borderColor}`;

  return (
    <Button
      variant={buttonType}
      style={{
        flexShrink: fullWidth ? 1 : 0,
      }}
      sx={{
        height,
        background:
          isContained || props.disabled
            ? isOutlined
              ? undefined
              : backgroundStyle
            : undefined,
        borderRadius: "8px",
        padding: `6px ${props.endIcon ? "13px" : "16px"} 6px ${props.startIcon ? "13px" : "16px"}`,
        color: textColor,
        width: fullWidth ? "100%" : undefined,
        maxWidth: fullWidth ? "100%" : undefined,

        border,
        "&.Mui-disabled": {
          border,
        },

        gap: "4px",
        ":hover": {
          background: !isContained
            ? "none"
            : `linear-gradient(to right, ${lighten(
                customGradientColor,
                0.05,
              )}, ${lighten(borderColor, 0.05)})`,
        },
        "& .MuiButton-startIcon": {
          margin: 0,
          opacity: props.loading || props.disabled ? "0.4" : "1",
        },
        "& .MuiButton-endIcon": {
          margin: 0,
          opacity: props.loading || props.disabled ? "0.4" : "1",
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};
